$(document).ready(function () {
    $('input, textarea, select').on('click', function () {
        $(this).removeClass('input-error');
    });
});